import * as actions from './toast-action';

const initialState = {
  isToastVisible: false,
  message: '',
  messageType: ''
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SHOW_TOAST:
      return { ...state,
        isToastVisible: action.isToastVisible,
        message: action.message,
        messageType: action.messageType };

    case actions.HIDE_TOAST:
      return { ...state, isToastVisible: action.isToastVisible };
    default :
      return { ...state };
  }
}
